import { Navigate, useLocation } from 'react-router-dom'

function hasProtectAccess() {
  return localStorage.getItem('dizeeProtected') === 'true'
}

export default function RequireProtect({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  if (!hasProtectAccess()) {
    return <Navigate to="/protect" replace state={{ from: location.pathname }} />
  }
  return <>{children}</>
}
